export default __webpack_public_path__ + "images/pdf.fe7a1728514121e3f56d9013a89f2427.svg";